(() => {
  'use strict';
  const configNode = document.getElementById('wb-balance-ab-config');
  if (!configNode || window.__wbBalanceABLoaded) return;
  window.__wbBalanceABLoaded = true;
  const cfg = JSON.parse(configNode.textContent);
  const key = '_wb_balance_ab';
  const prefix = 'wb-balance-9880-v1:';
  const route = cfg.root;
  const original = new Map();
  const allowed = new WeakSet();
  let active = null;
  let busy = false;
  let purchaseStarted = false;
  let submitted = false;
  let notice;
  const readCart = async () => {
    const response = await fetch(`${route}cart.js`, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('No se pudo comprobar el carrito.');
    return response.json();
  };
  const marked = item => ['A', 'B'].some(arm => item.properties?.[key] === prefix + arm);
  const eligible = cart => cart.currency === 'EUR' && (cart.item_count === 0 ||
    (cart.item_count === 1 && cart.items.length === 1 && Number(cart.items[0].variant_id) === cfg.variant && marked(cart.items[0])));
  function show(text, exit = true) {
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'wb-balance-ab-notice';
      notice.setAttribute('role', 'status');
      notice.style.cssText = 'padding:12px;margin:12px 0;border:1px solid #ccd5cb;border-radius:8px;font-size:14px;line-height:1.5;background:#fff;color:#222;';
      const price = document.querySelector('.b-price');
      if (price) price.insertAdjacentElement('afterend', notice);
      else (document.querySelector('main') || document.body).prepend(notice);
    }
    notice.replaceChildren(document.createTextNode(text));
    if (exit) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Comprar con las condiciones habituales';
      button.style.cssText = 'display:block;margin-top:8px;text-decoration:underline;cursor:pointer;';
      button.addEventListener('click', leave);
      notice.append(button);
    }
  }
  function forms() {
    return [...document.querySelectorAll('form[action*="/cart/add"]')].filter(form =>
      Number(form.querySelector('[name="id"]')?.value) === cfg.variant);
  }
  function restore() {
    for (const [node, text] of original) if (node.isConnected) node.textContent = text;
    document.querySelectorAll(`[name="properties[${key}]"]`).forEach(node => node.remove());
    active = null;
  }
  async function leave() {
    if (busy) return;
    busy = true;
    try {
      const cart = await readCart();
      // Use a fresh line key after each change: properties can merge cart lines.
      let current = cart;
      for (let i = 0; i < cart.items.length; i++) {
        const item = current.items.find(marked);
        if (!item) break;
        const properties = {...item.properties};
        // Shopify ignores an empty properties object. An explicit non-test value
        // exits the offer without removing the line or its other properties.
        properties[key] = 'off';
        const response = await fetch(`${route}cart/change.js`, {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: item.key, quantity: item.quantity, properties})
        });
        if (!response.ok) throw new Error('No se pudo actualizar el carrito. Inténtalo de nuevo.');
        current = await response.json();
      }
      if (current.items.some(marked)) throw new Error('No se ha podido salir de la oferta. Inténtalo de nuevo.');
      sessionStorage.setItem(prefix + 'optout', '1');
      restore();
      location.reload();
    } catch (error) { show(error.message); busy = false; }
  }
  function render(arm) {
    active = arm;
    const amount = arm === 'B' ? 98.80 : 93.81;
    const price = new Intl.NumberFormat('es-ES', {style: 'currency', currency: 'EUR'}).format(amount);
    document.querySelectorAll(`[data-sl-attribute-p="${cfg.product}"]`).forEach(node => {
      if (!original.has(node)) original.set(node, node.textContent);
      if (node.textContent !== price) node.textContent = price;
    });
    const compare = Number(cfg.compareAt) / 100;
    if (compare > amount) document.querySelectorAll(`[data-sl-attribute-discount="${cfg.product}"]`).forEach(node => {
      if (!original.has(node)) original.set(node, node.textContent);
      node.textContent = `-${Math.round((compare - amount) * 100 / compare)} %`;
    });
    const shippingText = arm === 'B' ? 'Envío estándar gratis a Península' : 'Envío estándar a Península: 4,99 €';
    document.querySelectorAll('.announcement-text').forEach(node => {
      if (/env[ií]o gratis.*100/.test(node.textContent.toLowerCase())) {
        if (!original.has(node)) original.set(node, node.textContent);
        node.textContent = shippingText;
      }
    });
    document.querySelectorAll('.b-stat').forEach(node => {
      if (!/env[ií]o/i.test(node.querySelector('.b-stat__value')?.textContent || '')) return;
      const value = node.querySelector('.b-stat__value');
      if (value) value.textContent = 'Envío estándar';
      const label = node.querySelector('.b-stat__label');
      if (label) label.textContent = shippingText;
    });
    document.querySelectorAll('.b-acc').forEach(node => {
      if (!/^env[ií]o$/i.test(node.querySelector('summary')?.textContent.trim() || '')) return;
      const body = node.querySelector('.b-acc__body');
      if (body) body.textContent = `${shippingText}. Oferta para una sola báscula, sin otros productos ni cupones. Otras opciones y destinos mantienen las condiciones habituales fuera de esta oferta.`;
    });
    // The experiment is limited to one Balance; avoid inviting mixed carts.
    document.querySelectorAll('.b-upsell').forEach(node => { node.hidden = true; });
    forms().forEach(form => {
      let input = form.querySelector(`[name="properties[${key}]"]`);
      if (!input) {input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; form.append(input);}
      input.value = prefix + arm;
    });
    show(arm === 'B'
      ? '98,80 € con envío estándar gratis a Península. Oferta para una sola báscula, sin otros productos ni cupones. Selecciona «Entrega en casa» al pagar.'
      : '93,81 € + 4,99 € de envío estándar a Península. Total: 98,80 €. Oferta para una sola báscula, sin otros productos ni cupones. Selecciona «Entrega en casa» al pagar.');
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!forms().includes(form)) return;
    purchaseStarted = true;
    if (!active) return;
    if (allowed.has(form)) { allowed.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || submitted) return;
    busy = true;
    try {
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const cart = await readCart();
      if (quantity !== 1 || cart.item_count !== 0) {
        show('Esta oferta es para una báscula sola. Revisa el carrito o elige las condiciones habituales para añadir más productos.');
        return;
      }
      // A replacement form may have been inserted by the theme since init.
      render(active);
      submitted = true;
      allowed.add(form);
      form.requestSubmit(event.submitter || undefined);
    } catch (error) { submitted = false; show(error.message); }
    finally { busy = false; }
  }, true);
  async function init() {
    try {
      const cart = await readCart();
      const existing = cart.items.find(marked);
      if (existing) show('Tu oferta Balance requiere una unidad, envío estándar a Península y ningún cupón. Total previsto: 98,80 €.');
      if (!cfg.enabled || cfg.country !== 'ES' || cfg.currency !== 'EUR' || cfg.page !== 'product' || cfg.currentProduct !== cfg.product || sessionStorage.getItem(prefix + 'optout') || !eligible(cart)) return;
      // Both arms are explicitly checked: false is not assumed to mean control.
      for (let attempt = 0; attempt < 40 && !window.shoplift?.isHypothesisActive; attempt++) await new Promise(resolve => setTimeout(resolve, 100));
      if (!window.shoplift?.isHypothesisActive) return;
      let arm = null;
      if (await window.shoplift.isHypothesisActive(cfg.a)) arm = 'A';
      else if (await window.shoplift.isHypothesisActive(cfg.b)) arm = 'B';
      if (!arm) return;
      if (purchaseStarted) return;
      // Assignment can be asynchronous. Do not change the displayed offer
      // after a purchase started or another tab changed the cart.
      const latest = await readCart();
      if (purchaseStarted || !eligible(latest)) return;
      const latestMarked = latest.items.find(marked);
      if (latestMarked && latestMarked.properties[key] !== prefix + arm) return;
      if (existing && existing.properties[key] !== prefix + arm) {
        show('El carrito conserva una oferta anterior. Revisa sus condiciones antes de continuar.');
        return;
      }
      render(arm);
    } catch (error) { console.warn('Balance: no se ha aplicado la oferta.', error.message); }
  }
  document.addEventListener('cart:refresh', () => { submitted = false; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
